declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanRequest, CounsellingPlanController, SaveIvfTreatmentCyclesInfoRequest, SaveTestMedCycleActivitiesRequest, SaveEggDonorEpisode, GenericProcPostRequest, S_Methods } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { NgbSearchDonarModal } from '../TreatmentCycle/searchdonar.modal';
import { NgbSearchDonarreModal } from '../TreatmentCycle/searchdonarre.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSearchCyclesModal } from '../../follow up/counsellingregistry/modal/searchcycles.modal';
@Component({
  selector: 'newfollicularscanepisode',
  templateUrl: './newfollicularscanepisode.modal.html',
  styleUrls: ['./newfollicularscanepisode.modal.scss']
})

export class NgbNewFollicularScanEpisodeModal implements OnInit {
  @Input() ActorDocCode;
  @Input() FormattedCode: string;
  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  LmpEgg: NgbDateStruct;
  ProtocolStartDate: NgbDateStruct;
  ProtocolEndDate: NgbDateStruct;
  DonorLmpEgg: NgbDateStruct;
  DonorProtocolStartDate: NgbDateStruct;
  DonorProtocolEndDate: NgbDateStruct;
  public FacilityName: string;
  public BranchName: string;
  public SelectedPatientFormatted: string;
  file: File;
  fileList: FileList;
  public isRequesting: boolean = false;
  public ShowList: boolean = true;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  private isvisible = true;


  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientDetails: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;

  @ViewChild('f') IdentitiesForm: NgForm;

  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();
    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.CurrentPatientDetails = this.CurrentPatientInfoByFormattedCodeController[0];
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  ActorCode: number;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService, private modalService: NgbModal,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.LoadPatients();
  }
  public Remarks: string;
  public CycleType: string;
  SaveEpisode() {
    var saveReq = new SaveEggDonorEpisode();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40490;
    saveReq.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    saveReq.CycleType = this.CycleType;
    saveReq.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    saveReq.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    saveReq.Remarks = this.Remarks;
    saveReq.ActorCode = this.CurrentPatientDetails.ActorCode;
    saveReq.FormattedCode = this.CurrentPatientDetails.FormattedCode;
    saveReq.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    saveReq.PatientName = this.CurrentPatientDetails.DisplayName;
    saveReq.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    saveReq.CreatedUserCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;        
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40490;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  public DonorName: string;
  public DonorFormattedCode: string;
  public DonorCycleCode: number;
  public DonorActorCode: number;  
  public DonorRegistrationCode: number;
  SelectCycle() {
    const modalRef = this.modalService.open(NgbSearchCyclesModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((val: any) => {
      this.DonorName = val.DisplayName;
      this.DonorFormattedCode = val.PatientRegNo;
      this.DonorCycleCode = val.Code;
      this.DonorActorCode = val.ActorCode;
      this.DonorRegistrationCode = val.PatientCode;
    });
  }
  ConvertDonorEpisode() {
    var saveReq = new SaveEggDonorEpisode();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40480;
    saveReq.EggLMPDate = new Date(this.parserFormatter.format(this.DonorLmpEgg));
    saveReq.ProtocolStartDate = new Date(this.parserFormatter.format(this.DonorProtocolStartDate));
    saveReq.ProtocolEndDate = new Date(this.parserFormatter.format(this.DonorProtocolEndDate));
    saveReq.ActorCode = this.CurrentPatientDetails.ActorCode;
    saveReq.FormattedCode = this.CurrentPatientDetails.FormattedCode;
    saveReq.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    saveReq.PatientName = this.CurrentPatientDetails.DisplayName;

    saveReq.DonorName = this.DonorName;
    saveReq.DonorFormattedCode = this.DonorFormattedCode;
    saveReq.DonorCycleCode = this.DonorCycleCode;
    saveReq.DonorActorCode = this.DonorActorCode;    
    saveReq.DonorRegistrationCode = this.DonorRegistrationCode;    
    saveReq.Remarks = this.Remarks;
    saveReq.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    saveReq.CreatedUserCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40480;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
}

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start


